import React from 'react';
import PropTypes from 'prop-types';
import ReactFireComponent from '../react-fire-component/react-fire-component';
import CreateCategoryDialog from './create-category-dialog';

/** @class CategorySelect
  * A component to allow the selection of an affiliate category
  * @param {string} value - the selected category
  * @param {function} onChange - an event handler for a change event
  */
export default class CategorySelect extends ReactFireComponent {
  /** @constructor
    * Constructs a new instance of ExhibitorSelect
    */
  constructor(props) {
    super(props);
    this.state = {
      categories: [],
      showNewDialog: false
    }
    this.handleChange = this.handleChange.bind(this);
  }
  /** @method componentWillMount
    * Binds the component to the firebase database
    */
  componentWillMount() {
    this.bindAsArray('/affiliateCategories', 'categories');
  }
  /** @method componentWillUnmount
    * Unbinds the component from firebase database
    */
  componentWillUnmount() {
    this.unbind('categories');
  }
  /** @function handleChange
    * Applies user changes to the state
    * @param {InputEvent} event - the triggering event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    if(value === 'add-new-category') {
      this.setState({showNewDialog: true});
    } else {
      this.props.onChange(event);
    }
  }
  /** @method render
    * Renders the component
    */
  render() {
    const categories = this.state.categories
    .sort((a,b) => a.name.localeCompare(b.name))
    .map(category => (
      <option key={category.id} value={category.name}>
        {category.name}
      </option>
    ));
    return (
      <div className="input-group">
        <CreateCategoryDialog show={this.state.showNewDialog} onExit={()=>this.setState({showNewDialog: false})}/>
        <label htmlFor="category">Category</label>
        <select name="category" value={this.props.value} onChange={this.handleChange}>
          <option value="">Please Select</option>
          {categories}
          <option value="add-new-category">[Add New Category]</option>
        </select>
      </div>
    );
  }
}

CategorySelect.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/affiliate-list/category-select.js